import React from 'react';

function AdminSettings({ session }) {
  return (
    <div className="admin-settings-grid">
      <section className="admin-panel">
        <span className="admin-overline">ACCOUNT</span>
        <h2>Administrator access</h2>
        <dl className="settings-list">
          <div>
            <dt>Signed in as</dt>
            <dd>{session.user.email}</dd>
          </div>
          <div>
            <dt>Authentication</dt>
            <dd>Supabase email and password</dd>
          </div>
          <div>
            <dt>Authorization</dt>
            <dd>Active newsroom administrator</dd>
          </div>
        </dl>
      </section>

      <section className="admin-panel">
        <span className="admin-overline">AUTOMATION</span>
        <h2>RSS ingestion</h2>
        <dl className="settings-list">
          <div>
            <dt>Schedule</dt>
            <dd>Every fifteen minutes</dd>
          </div>
          <div>
            <dt>Function</dt>
            <dd>rss-ingest</dd>
          </div>
          <div>
            <dt>Database</dt>
            <dd>Supabase news tables</dd>
          </div>
        </dl>
        <p className="settings-note">
          The Edge Function must be deployed in Supabase for
          scheduled and manual imports to work.
        </p>
      </section>
    </div>
  );
}

export default AdminSettings;